export const CHAT = 'Chat';
export const EMAIL = 'Email';
export const JIT_ESCALATION = 'JIT_ESCALATION';
